import { render, staticRenderFns } from "./FolhaPagamentoForm.vue?vue&type=template&id=77857dbd&scoped=true&"
import script from "./FolhaPagamentoForm.vue?vue&type=script&lang=js&"
export * from "./FolhaPagamentoForm.vue?vue&type=script&lang=js&"
import style0 from "./FolhaPagamentoForm.vue?vue&type=style&index=0&id=77857dbd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77857dbd",
  null
  
)

export default component.exports